import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../hooks/useAdminAuth';

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `flex items-center px-4 py-2 text-sm rounded-md ${
    isActive
      ? 'bg-gray-700 text-white'
      : 'text-gray-300 hover:bg-gray-700 hover:text-white'
  }`;

const DashboardLayout: React.FC = () => {
  const { logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <div className="w-64 bg-gray-800">
        <div className="flex items-center justify-center h-16 px-4 bg-gray-900">
          <h1 className="text-xl font-bold text-white">Dove2 Admin</h1>
        </div>
        <div className="p-4">
          <p className="mb-4 text-xs text-gray-400 uppercase">Navigation</p>
          <nav className="space-y-2">
            <NavLink to="/admin/dashboard" className={navLinkClass}>
              Overview
            </NavLink>
            <NavLink to="/admin/questions" className={navLinkClass}>
              Questions
            </NavLink>
            <NavLink to="/admin/email-threads" className={navLinkClass}>
              Email Threads
            </NavLink>
            <NavLink to="/admin/personas" className={navLinkClass}>
              Persona Analytics
            </NavLink>
            <NavLink to="/admin/chats" className={navLinkClass}>
              Chat Analytics
            </NavLink>
            <NavLink to="/admin/research" className={navLinkClass}>
              Research Queries
            </NavLink>
          </nav>
        </div>
        <div className="absolute bottom-0 w-64 p-4">
          <button
            onClick={handleLogout}
            className="flex items-center w-full px-4 py-2 text-sm text-gray-300 rounded-md hover:bg-gray-700 hover:text-white"
          >
            Logout
          </button>
        </div>
      </div>

      <div className="flex flex-col flex-1 overflow-hidden">
        <header className="flex items-center justify-between px-6 py-4 bg-white border-b">
          <h2 className="text-xl font-semibold text-gray-800">Dashboard</h2>
          <div className="flex items-center">
            <span className="mr-2 text-sm text-gray-600">Admin User</span>
          </div>
        </header>
        <main className="flex-1 p-6 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
